import React from 'react';

import ForgotForm from '../components/ForgotForm';

const Forgot: React.FC = () => <ForgotForm />;

export default Forgot;
